import { render } from "./MyBookings.vue?vue&type=template&id=34cbb2c8"
import script from "./MyBookings.vue?vue&type=script&lang=js"
export * from "./MyBookings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__